export const storageDataKeyName = {
    holidayBooking: 'holidayBooking',
    teamCalendarEvents: 'teamCalendarEvents',
    user: 'user',
};
export const storageImageKeyName = {
    abdooLogo64: 'abdooLogo64',
    abdooLogo128: 'abdooLogo128',
    newOrbitLogo: 'newOrbitLogo',
};
export const storageDataKeys = Object.keys(storageDataKeyName);
export const storageImageKeys = Object.keys(storageImageKeyName);
